module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-30 m-t-10 w-500",
    staticStyle: {
      "background-color": "#fff",
      "padding": "20px"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "规则名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.title),
      expression: "form.title",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        _vm.form.title = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规则标识",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.name),
      expression: "form.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        _vm.form.name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "父节点",
      "prop": "pid"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pid),
      expression: "form.pid"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "父节点"
    },
    domProps: {
      "value": (_vm.form.pid)
    },
    on: {
      "input": function($event) {
        _vm.form.pid = $event
      }
    }
  }, _vm._l((_vm.options), function(item) {
    return (!item.remove) ? _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.id
      }
    }) : _vm._e()
  }))]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.edit('form')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c39dcb2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrative/system/rule/edit.vue
// module id = 1986
// module chunks = 2